<template>
  <section
    class="technologies-split section"
    :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]"
  >
    <div class="container">
      <div
        class="technologies-split-inner section-inner"
        :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]"
      >
        <c-section-header :data="sectionHeader" class="center-content" />
        <div
          class="split-wrap"
          :class="[
                        invertMobile && 'invert-mobile',
                        invertDesktop && 'invert-desktop',
                        alignTop && 'align-top'
                    ]"
        >
          <div class="split-item">
            <div
              class="split-item-content center-content-mobile reveal-from-right"
              data-reveal-container=".split-item"
            >
              <h3 class="mt-0 mb-12">Node.js + Vue.js</h3>
              <p
                class="m-0"
              >Full-stack javasript works for companies like AirBnB, Paypal, LinkedIn, and Netflix, and it'll work for your clients too. There are thousands of qualified developers on any job board with the skills to deploy, extend, and maintain the software I build.</p>
            </div>
            <div
              class="split-item-image reveal-from-left"
              data-reveal-container=".split-item"
              :class="imageFill && 'split-item-image-fill'"
            >
              <c-image
                :src="require('@/assets/images/technology-split-image-01.svg')"
                alt="Technologies split image 01"
                :width="528"
                :height="396"
              />
            </div>
          </div>

          <div class="split-item">
            <div
              class="split-item-content center-content-mobile reveal-from-left"
              data-reveal-container=".split-item"
            >
              <h3 class="mt-0 mb-12">Google Firebase</h3>
              <p
                class="m-0"
              >For rapid web app MVP development, there's nothing like Firebase from Google. It helps developers handle messy elements like user authentication (i.e. registering/logging in), controlling access permissions, and making data reactive (i.e. real time updates without having to reload the web page). Not to mention hosting.</p>
            </div>
            <div
              class="split-item-image reveal-from-right"
              data-reveal-container=".split-item"
              :class="imageFill && 'split-item-image-fill'"
            >
              <c-image
                :src="require('@/assets/images/technology-split-image-02.svg')"
                alt="Technologies split image 02"
                :width="528"
                :height="396"
              />
            </div>
          </div>

          <div class="split-item">
            <div
              class="split-item-content center-content-mobile reveal-from-right"
              data-reveal-container=".split-item"
            >
              <h3 class="mt-0 mb-12">GitHub + Plain English Clean Code</h3>
              <p
                class="m-0"
              >I'm a native English speaker like you are, and that gets reflected in the clarity of my code. My variable names make logical sense. My git commit messages are descriptive, easy to read, and unambiguous. My ReadMe files are clear and concise, without jargon.</p>
            </div>
            <div
              class="split-item-image reveal-from-left"
              data-reveal-container=".split-item"
              :class="imageFill && 'split-item-image-fill'"
            >
              <c-image
                :src="require('@/assets/images/technology-split-image-03.svg')"
                alt="Technologies split image 03"
                :width="528"
                :height="396"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionSplitProps } from "@/utils/SectionProps.js";
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
import CImage from "@/components/elements/Image.vue";

export default {
  name: "CTechnologiesSplit",
  components: {
    CSectionHeader,
    CImage
  },
  mixins: [SectionSplitProps],
  data() {
    return {
      sectionHeader: {
        title: "Rock-solid modern web app technologies",
        paragraph:
          "I don't chase the latest shiny web frameworks, but I'm also not stuck in the past. My tech stack is reliable, industry-standard, easy to hire for, and easy to build on top of."
      }
    };
  }
};
</script>